export const normalizeSellerUsername=(value='')=> String(value).trim().toLowerCase();

export const getSellerId=(seller)=> seller?.id || null;

export const findSellerByIdentity=(sellers=[],identity={})=> {
  const sellerId=identity.id || identity.sellerId;
  const username=normalizeSellerUsername(identity.username || identity.shop_username);
  const userId=identity.userId;

  return sellers.find(seller=> {
    if (sellerId && seller.id===sellerId) return true;
    if (userId && seller.user_id===userId) return true;

    return Boolean(
      username &&
      normalizeSellerUsername(seller.shop_username)===username
    );
  }) || null;
};

export const getOrderSellerId=(order,sellers=[])=> {
  if (order?.seller_id) return order.seller_id;
  if (order?.seller?.id) return order.seller.id;

  const seller=findSellerByIdentity(sellers,{
    username: order?.seller?.shop_username
  });

  return seller?.id || null;
};

export const getOrdersForSeller=(orders=[],seller,sellers=[])=> {
  const sellerId=getSellerId(seller);

  if (!sellerId) return [];

  return orders.filter(order=> {
    const orderSellerId=getOrderSellerId(order,sellers);
    return orderSellerId===sellerId;
  });
};